// extracted by mini-css-extract-plugin
module.exports = {"sns-box-wrap":"SNSbox_sns-box-wrap__2zr05","sns-box__heading":"SNSbox_sns-box__heading__14s0c","icons":"SNSbox_icons__2-LFM","sns-box":"SNSbox_sns-box__1i2fd"};